import { getDefaultStore } from 'jotai';
import { jotaiStore } from './jotai-store';
import type { Atom, WritableAtom } from 'jotai';

/**
 * Utility functions for working with Jotai atoms outside of React components
 */

/**
 * Get the current value of a Jotai atom
 *
 * @param atom - The Jotai atom to read
 * @returns The current value of the atom
 *
 * @example
 * ```typescript
 * const token = getAtomValue(jwtTokenState);
 * ```
 */
export const getAtomValue = <T>(atom: Atom<T>): T => {
  // Prefer the shared store to avoid multiple store instances
  return (jotaiStore ?? getDefaultStore()).get(atom);
};

/**
 * Set the value of a Jotai atom
 *
 * @param atom - The Jotai atom to write to
 * @param value - The new value to set
 *
 * @example
 * ```typescript
 * setAtomValue(jwtTokenState, 'new-token');
 * setAtomValue(jwtTokenState, null);
 * ```
 */
export const setAtomValue = <T>(
  atom: WritableAtom<T, [T], void>,
  value: T,
): void => {
  (jotaiStore ?? getDefaultStore()).set(atom, value);
};
